module.exports = __webpack_public_path__ + "static/media/M&F-logo.94774d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/M&F-logo.png
// module id = 1000
// module chunks = 0